import {useState, useRef, useEffect} from "react";

/**
 * Dropdown button that displays a list of options when clicked
 *
 * @param props.options String options that a button has
 * @param props.button Object that contains button id(string), text(string), action(function).
 * @param props.prefix String that is affixed to options.
 * @param props.loading Boolean that indicates status of request of server.
 * @param props.displayLoading  Function that performs actions while data is loading.
 * @return JSX
 */
export function CdaWebModalDownloadDropdownButton(props) {
    const [isOpen, setIsOpen] = useState(false);
    const {options, button, prefix, loading, displayLoading} = props;
    const dropdownRef = useRef(null);
    const isSingleItem = options.length === 1;


    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleClick = (type) => {
        if(displayLoading)
        {
            displayLoading();
        }

        if (button.action) {
            button.action(type);
        }
        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        const isPillClicked = event.target.id === "dropdownbutton" || event.target.parentElement?.id === "dropdownbutton";

        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            if (!isPillClicked) {
                setIsOpen(false);
            }
        }
    };

    const showDataSpinner = (
                         <div className = "cdaWebModalDownloadDataFilesButton">
                           <div className="cdaWebModalButtonSpinner"></div>
                         </div>
                         );

    const showAudioSpinner = (
                         <div className = "cdaWebModalDownloadAudioFilesButton">
                           <div className="cdaWebModalButtonSpinner"></div>
                         </div>
                         );


    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
      <div>
        {isSingleItem &&
         (
             <div
               key={button.text}
               className={`cdaWebModalDropdownButtonContainer cdaWebModalDropdownButton`}
               onClick={()=>handleClick(options[0])}>{loading ? showAudioSpinner : button.text}
             </div>
         )}

         {!isSingleItem &&
           (
             <div
               className = {"cdaWebModalDropdownButtonContainer cdaWebModalDropdownButton"}
               ref={dropdownRef}
               key={button.text}
               onClick={()=>toggleDropdown()}>{ loading ? showDataSpinner : (<span>{button.text + ' ▼'}</span>)}
               {isOpen && (
                 <div id="dropdownbutton" className={`cdaWebModalDropdownListContainer ${isOpen ? 'cdaWebModalDropdownListContainerOpen' : ''}`}>
                   <ul className="cdaWebModalDropdownList">
                     {options.map((option) => (
                       <li key={option} onClick={()=>handleClick(option)}>
                         {`${prefix} ${option.toUpperCase()}`}
                       </li>))
                     }
                   </ul>
                 </div>)}
             </div>
           )}
      </div>
  );
}
